import styled from 'styled-components';

export const NavList = styled.ul`
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  // align-items: stretch;

  @media (min-width: ${({ theme }) => theme.breakpoint.md}) {
    border-radius: 20px;
    overflow: hidden;
  }
`;

export const NavItem = styled.li`
  font-weight: bold;
  display: inline-block;
  flex-grow: 1;
  text-align: center;
  margin-bottom: 0;

  a {
    display: block;
    height: 100%;
    padding: ${({ theme }) => theme.spacing.sm};
    text-decoration: none;
    background-color: rgba(255, 255, 255, 0.4);
    color: white;

    &:hover {
      background-color: rgba(255, 255, 255, 0.6);
    }

    &.active {
      color: black;
    }
  }
`;
